export const MY_ORDER_LIST = 'MY_ORDER_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-order/store/mutations-types.js